// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminB2bPaymentSearchResponse

import { hydrateAdminB2bPaymentListItem, type AdminB2bPaymentListItem, type AdminB2bPaymentListItemApiResponse } from './adminB2bPaymentListItem.gen';

export type AdminB2bPaymentSearchApiResponse = {
	items: AdminB2bPaymentListItemApiResponse[];
};

export type AdminB2bPaymentSearch = {
	items: AdminB2bPaymentListItem[];
};

export function hydrateAdminB2bPaymentSearch(data: AdminB2bPaymentSearchApiResponse): AdminB2bPaymentSearch {
	return {
		...data,
		items: data.items.map(hydrateAdminB2bPaymentListItem),
	};
}